import { defineStore } from "pinia";
import axios from "axios";
import { handleError, handleResponse } from "js/lib/server.js";

function objectToFormData(obj) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(obj)) {
        if (typeof value === "object" && !(value instanceof File)) {
            formData.append(key, JSON.stringify(value));
        } else {
            formData.append(key, value);
        }
    }
    return formData;
}

export const useAxiosStore = defineStore("axiosStore", {
    state: () => {
        return {
            uploadProgress: 0,
            isUploading: false,
            uploadError: null,
        };
    },
    actions: {
        setUploadError(error) {
            this.uploadError = error;
        },
        clearUploadError() {
            this.uploadError = null;
        },
        fetch(url, params) {
            return axios
                .get(url, { params: params ?? {} })
                .catch(handleError)
                .then(handleResponse);
        },
        upload(url, data, method) {
            const config = {
                params: {},
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                onUploadProgress: (progressEvent) => {
                    if (!progressEvent.total) {
                        this.uploadProgress = 0;
                        return;
                    }
                    this.uploadProgress = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                },
            };
            if (method) {
                config.params._method = method;
            }

            this.isUploading = true;
            this.uploadProgress = 0;
            this.uploadError = null;

            return axios
                .post(url, objectToFormData(data), config)
                .catch(handleError)
                .then(handleResponse)
                .finally(() => {
                    this.isUploading = false;
                });
        },
        create(url, data, withUpload) {
            if (withUpload) {
                return this.upload(url, data);
            }
            return axios
                .post(url, data, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .catch(handleError)
                .then(handleResponse);
        },
        edit(url, data, withUpload) {
            if (withUpload) {
                return this.upload(url, data, "PUT");
            }
            return axios
                .put(url, data, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .catch(handleError)
                .then(handleResponse);
        },
        delete(url) {
            return axios.delete(url).catch(handleError).then(handleResponse);
        },
    },
});
